var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVkLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#VK-Logo_svg__clip0_2_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 48c0-22.627 0-33.941 7.03-40.97C14.558 0 25.872 0 48.5 0h4c22.627 0 33.941 0 40.97 7.03 7.03 7.029 7.03 18.343 7.03 40.97v4c0 22.627 0 33.941-7.03 40.97C86.442 100 75.128 100 52.5 100h-4c-22.627 0-33.941 0-40.97-7.03C.5 85.942.5 74.628.5 52v-4z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.709 72.042c-22.792 0-35.792-15.625-36.334-41.625h11.417C29.167 49.5 37.583 57.584 44.25 59.25V30.417H55v16.458c6.584-.708 13.5-8.208 15.833-16.458h10.75c-1.791 10.167-9.291 17.667-14.625 20.75 5.334 2.5 13.876 9.042 17.126 20.875H72.25C69.708 64.125 63.375 58 55 57.167v14.875H53.71z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "VK-Logo_svg__clip0_2_40"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h100v100H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkLogo);
export default __webpack_public_path__ + "static/media/VK-Logo.16661eb0178743f18693a6ad94443f44.svg";
export { ForwardRef as ReactComponent };